import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HoverRightArrow from "web/assets/images/dropdown-menu-hover-arrow.png";
import './dropDownMenu.scss';

const DropDownMenuNearBy = (props) => {
  const [click, setClick] = useState(false);
  const dispatch = useDispatch();
  const handleClick = () => setClick(!click);
  const pageLanguageContents = props.content
  const userType = localStorage.getItem('accountType')
  const storedData = useSelector((state) => state.storedData.payload);
  let disableFlg = storedData?.guestUser

  let MenuItems;
  if (disableFlg) {
    MenuItems = [
      {
        title: pageLanguageContents?.Header[15]?.H_Needs,
        //path: '/nearby-needs?params=true&pageType=PostLoad&expanded=sideBar',
        path: '/nearby-needs',
        cName: 'dropdown-link',
        type: 'SearchPostLoadScreen'
      },
      {
        title: pageLanguageContents?.Header[16]?.H_Inventory,
        //path: '/nearby-inventory?params=true&pageType=PostInventory&expanded=sideBar',
        path: '/nearby-inventory',
        cName: 'dropdown-link',
        type: 'SearchPostScreen'
      }
    ];
  } else {
    if (userType === "Both") {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[15]?.H_Needs,
          //path: '/nearby-needs?params=true&pageType=PostLoad&expanded=sideBar',
          path: '/nearby-needs',
          cName: 'dropdown-link',
          type: 'SearchPostLoadScreen'
        },
        {
          title: pageLanguageContents?.Header[16]?.H_Inventory,
          //path: '/nearby-inventory?params=true&pageType=PostInventory&expanded=sideBar',
          path: '/nearby-inventory',
          cName: 'dropdown-link',
          type: 'SearchPostScreen'
        }
      ];
    }
    else if (userType === "Buyer") {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[16]?.H_Inventory,
          //path: '/nearby-inventory?params=true&pageType=PostInventory&expanded=sideBar',
          path: '/nearby-inventory',
          cName: 'dropdown-link',
          type: 'SearchPostScreen'
        }
      ];
    }
    else if (userType === "Seller") {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[15]?.H_Needs,
          // path: '/nearby-needs?params=true&pageType=PostLoad&expanded=sideBar',
          path: '/nearby-needs',
          cName: 'dropdown-link',
          type: 'SearchPostLoadScreen'
        }
      ];
    } else {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[15]?.H_Needs,
          //path: '/nearby-needs?params=true&pageType=PostLoad&expanded=sideBar',
          path: '/nearby-needs',
          cName: 'dropdown-link',
          type: 'SearchPostLoadScreen'
        },
        {
          title: pageLanguageContents?.Header[16]?.H_Inventory,
          //path: '/nearby-inventory?params=true&pageType=PostInventory&expanded=sideBar',
          path: '/nearby-inventory',
          cName: 'dropdown-link',
          type: 'SearchPostScreen'
        }
      ];
    }
  }

  const onLinkClick = (type) => {
    if (type === 'SearchPostLoadScreen') {
      let obj = {
        title: '',
        params: 'true',
        pageType: "PostLoad",
        expanded: 'sideBar'
      }
      dispatch({ type: 'SEARCH_POST', payload: obj })
    }
    if (type === 'SearchPostScreen') {
      let obj = {
        title: '',
        params: 'true',
        pageType: "PostInventory",
        expanded: 'sideBar',
        tabType: ''
      }
      dispatch({ type: 'SEARCH_INVENTORY', payload: obj })
    }
  };
  return (
    <>
      <ul className={click ? 'dropdown-menu1 clicked' : 'dropdown-menu1'}>
        {MenuItems.map((item, index) => {
          return (
            <>{index === 0 && disableFlg ?
              <li key={index}>
                <div className='opacityDisable'>
                  <img
                    className="arrow-image"
                    src={HoverRightArrow}
                    alt="right-arrow"
                  />
                  {item.title}
                </div>
              </li> :
              <li key={index}>
                <Link
                  className={item.cName}      
                  to={item.path}
                  onClick={() => onLinkClick(item.type)}
                >
                  <img
                    className="arrow-image"
                    src={HoverRightArrow}
                    alt="right-arrow"
                  />
                  {item.title}
                </Link>
              </li>
            }</>
          );
        })}
      </ul>
    </>
  );
}

export default DropDownMenuNearBy;